var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 94.041,
    style: {
      fill: "#FFAD1D"
    },
    width: 512,
    height: 323.918
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.955,
    y: 94.041,
    style: {
      fill: "#FF8900"
    },
    width: 257.045,
    height: 323.918
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F18"
    },
    d: "M512,94.041v5.057L273.638,245.269c-5.726,3.48-12.225,5.13-18.683,4.921 c-5.757-0.167-11.483-1.818-16.593-4.921L0,96.778v-2.738H512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3400"
    },
    d: "M512,94.041v5.057L273.638,245.269c-5.726,3.48-12.225,5.13-18.683,4.921V94.041H512z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c2a9731956828d4c1363224cf772d518.svg";
export { ForwardRef as ReactComponent };